import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import CustomHeaderTitle from "../../constants/CustomHeaderTitle";
import HeaderBread from "../../HeaderBread";
import MobilePagemasterInput from "./MobilePagemasterInput";
import ShipMobilePagemasterInput from "./ShipMobilePagemasterInput";

const EditMobilePageDataShip = ({ category, pageData }) => {
  const params = useParams();
  const [{ permission, userDetails }, dispatch] = useDataLayerValue();
  const [navigation, setNavigation] = useState([]);
  const [vesselOptions, setVesselOptions] = useState([]);
  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    getOptionLocation();
  }, []);
  useEffect(() => {
    console.log({ pageData });
  }, [pageData]);
  useEffect(() => {
    console.log({ category });
    if (category?.id)
      setNavigation([
        {
          title: "Home",
          route: "/",
        },
        {
          title: "Mobile App Shore CMS",
          route: "/",
        },
        {
          title: "All Pages",
          route: "/ship/all-pages/genting-dream/" + category.id,
        },
        {
          title: vesselOptions.find((item) => item.id == category?.vessel_id)
            ?.name,
          route:
            "/ship/all-pages/" +
            vesselOptions
              .find((item) => item.id == category?.vessel_id)
              ?.name?.replaceAll(" ", "-")
              ?.toLowerCase() +
            "/" +
            +category.id,
        },
        {
          title: category?.name,
          route:
            "/ship/all-pages/" +
            vesselOptions
              .find((item) => item.id == category?.vessel_id)
              ?.name?.replaceAll(" ", "-")
              ?.toLowerCase() +
            "/" +
            +category.id,
        },
      ]);
  }, [vesselOptions, category]);

  return (
    <Layout allowPermission type={"create_per"} module_data={"All Pages"}>
      <CustomHeaderTitle title={"Edit Categories"} />
      <HeaderBread
        navigation={navigation}
        title={"Edit " + category?.name + " Page"}
      ></HeaderBread>
      {category && pageData && (
        <ShipMobilePagemasterInput category={category} pageData={pageData} />
      )}
    </Layout>
  );
};

export default EditMobilePageDataShip;
